import { Doc, DocStatus } from 'types/entities'

import { useOnUpdateDocStatus } from 'state/docs/hooks'

import { notifications } from 'constants/notifications'

import { useOpenModal } from 'modal'
import { newConfirmModal } from 'modals'
import { CellProps } from 'components/ui'

import { useCallNotification } from 'notifications/hooks'
import { NotificationTypes } from 'notifications/service'

import { ButtonClose } from '../Style'

type Props = {
  content?: string
  updateData: () => Promise<void>
}

type DeclineProps = CellProps<Doc> & Props

export function DeclineVerification({ row, content, updateData }: DeclineProps) {
  const openModal = useOpenModal()
  const callNotification = useCallNotification()
  const { onUpdateDocStatus, ...request } = useOnUpdateDocStatus()

  const { id } = row.original

  const handleDecline = () => {
    openModal(newConfirmModal({ action: handleUpdateStatus }))
  }

  const handleUpdateStatus = async () => {
    try {
      await onUpdateDocStatus({ id, status: DocStatus.DECLINED })

      await updateData()
    } catch (err) {
      callNotification({ type: NotificationTypes.ERROR, message: notifications.errors.changeKycStatus(err.message) })
    }
  }

  return (
    <ButtonClose type='outline' size='medium' loadingText='' onClick={handleDecline} isLoading={request.isLoading}>
      {content ? content : 'Decline'}
    </ButtonClose>
  )
}
